import React from "react";
import { Form, Spinner } from "react-bootstrap";
import { useFormik, FormikProvider, ErrorMessage } from "formik";
import * as yup from "yup";
import { usePostAccountDetailMutation } from "../../../../rtk-query/slices/onboarding/accountDetailSlice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function AccountDetailsTabContent({ setCurrentTab }) {
  const [postAccountDetail, { isLoading }] = usePostAccountDetailMutation();
  const navigate = useNavigate();

  const validationSchema = yup.object({
    accountTitle: yup.string().required("Account title is required"),
    accountNumber: yup
      .string()
      .required("Account number is required")
      .min(5, "Account number must be at least 5 characters")
      .max(34, "Account number cannot exceed 34 characters"),
    ibanNumber: yup
      .string()
      .required("IBAN is required")
      .matches(/^[A-Za-z0-9]+$/, "IBAN must be alphanumeric")
      .min(5, "IBAN must be at least 5 characters")
      .max(25, "IBAN cannot exceed 25 characters"),
    bankDetails: yup
      .string()
      .required("Bank Name are required")
      .matches(/^[A-Za-z\s]+$/, "Bank name must be letters"),
  });

  const formik = useFormik({
    initialValues: {
      accountTitle: "",
      accountNumber: "",
      bankDetails: "",
      ibanNumber: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        // Logic to save account details
        console.log("Account Details Submitted:", values);
        // Move to next tab
        const formData = new FormData();
        formData.append("account_holder_name", values.accountTitle);
        formData.append("bank_name", values.bankDetails);
        formData.append("account_number", values.accountNumber);
        formData.append("iban_number", values.ibanNumber);
        const response = await postAccountDetail(formData);
        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          navigate("/");
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (response?.error?.status == 401) {
            localStorage.removeItem("DODLoginToken");
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
            navigate("/login");
          } else if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                const combinedErrors = errors[field].join(" ");
                // if (field === "supplier_type") {
                //   setFieldError("option", combinedErrors);
                // }
              }
            }
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } catch (error) {
        // Handle any errors
        toast.error("An unexpected error occurred. Please try again.");
      }
    },
  });

  return (
    <div className="ob-pi-form-container">
      <h3 className="ob-pi-form-heading m-0">
        Your account details to get payments
      </h3>
      <p className="ob-pi-form-description m-0">
        This shall be used when you redeem vouchers on your bookings completion
      </p>

      <FormikProvider value={formik}>
        <Form className="mt-4" onSubmit={formik.handleSubmit}>
          <h4 className="ob-pi-form-heading mt-3">Account Details</h4>

          <Form.Group controlId="accountTitle" className="mt-3">
            <Form.Label>
              Account Title<span className="text-danger ps-1">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter account title"
              className="ob-pi-input"
              name="accountTitle"
              value={formik.values.accountTitle}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <ErrorMessage
              name="accountTitle"
              component="div"
              className="text-danger mb-2"
            />
          </Form.Group>

          <Form.Group controlId="ibanNumber" className="mt-3">
            <Form.Label>
              IBAN no<span className="text-danger ps-1">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter IBAN no"
              className="ob-pi-input"
              name="ibanNumber"
              value={formik.values.ibanNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <ErrorMessage
              name="ibanNumber"
              component="div"
              className="text-danger mb-2"
            />
          </Form.Group>

          <Form.Group controlId="accountNumber" className="mt-3">
            <Form.Label>
              Account no/card no<span className="text-danger ps-1">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter account number"
              className="ob-pi-input"
              name="accountNumber"
              value={formik.values.accountNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <ErrorMessage
              name="accountNumber"
              component="div"
              className="text-danger mb-2"
            />
          </Form.Group>

          <Form.Group controlId="bankDetails" className="mt-3">
            <Form.Label>
              Bank Name<span className="text-danger ps-1">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name of bank"
              className="ob-pi-input"
              name="bankDetails"
              value={formik.values.bankDetails}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <ErrorMessage
              name="bankDetails"
              component="div"
              className="text-danger mb-2"
            />
          </Form.Group>

          <div className="d-flex justify-content-between mt-5">
            <button
              type="button"
              className="back-btn"
              onClick={() => setCurrentTab(4)}
            >
              Back
            </button>
            <button
              type="submit"
              className="submit-btn"
              disabled={formik.isSubmitting}
            >
              {!formik.isSubmitting ? (
                "Save & Continue"
              ) : (
                <>
                  Save & Continue <Spinner size="sm" />
                </>
              )}
            </button>
          </div>
        </Form>
      </FormikProvider>
    </div>
  );
}

export default AccountDetailsTabContent;
